<div class="table-responsive" id="table">
  <form class="" *ngIf="filterItems && filterItems.length > 0">
    <div class="d-flex pt-3 justify-content-around">
      <div *ngFor="let filterOption of filterItems" class="">
        <div *ngIf="filterOption.dropdown" class="fieldset">
          <label class="legend">{{filterOption.label}}</label>
          <select (change)="setValueForDropdownFilter($event.target.value, filterOption.label)" class="text-field filter-dropdown">
            <option selected disabled></option>
            <option *ngFor="let option of filterOption.dropdownOptions" [value]="option.value">{{option.displaytext}}</option>
            <option disabled></option>
          </select>
        </div>
        <div *ngIf="filterOption.date">
          <div class="fieldset">
            <label class="legend" for="price">{{filterOption.label}}</label>
            <input (change)="onFilterInputChange()" type="datetime-local" [(ngModel)]="filterOption.value" name="fromDate" class="text-field filter-date">
          </div>
        </div>
        <div *ngIf="filterOption.checkbox">
          <div class="fieldset">
            <label class="legend">{{filterOption.label}}</label>
            <input (change)="onFilterInputChange()" type="checkbox" [(ngModel)]="filterOption.value" class="text-field">
          </div>
        </div>
      </div>
    </div>
    <button type="button" [disabled]="filterHasValue()" (click)="clearFilter()" class="btn btn-primary mx-auto my-3">Clear Filter</button>
  </form>

  <table #tableElement class="table align-items-center table-flush table-hover" *ngIf="displayedData.length > 0 else empty">
    <thead class="thead-light">
      <tr>
        <th *ngIf="allowMultiSelect && operation?.length > 0"><input id="headselect" (click)="onCheckBoxClicked($event)" type="checkbox"></th>
        <th class="handCursor"> S/N
        </th>
        <ng-container *ngFor="let column of displayedData[0] | keyvalue">
          <ng-container *ngIf="shouldDisplayColumn(column.key)">
            <th class="handCursor">
              {{column.key.substring(2)}}
              <!-- <i *ngIf="sortBy == column.key && sortAsc" class="ml-1 fas fa-caret-up"></i>
              <i *ngIf="sortBy == '' && !sortAsc" class="ml-1 fas fa-caret-down"></i> -->
            </th>
          </ng-container>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of displayedData; let i = index" 
        [ngClass]="{'bg-customgreen':item['passed'], 'bg-customorange': !item['passed']  && item['passed'] !== undefined  && item['completedLessons'] != 0}" >
        <td *ngIf="allowMultiSelect"><input #selectrow type="checkbox" [id]="i" (click)="onCheckBoxClicked($event)"></td>
        <td>{{i + 1}}</td>
        <ng-container *ngFor="let property of item | keyvalue">
          <ng-container *ngIf="shouldDisplayColumn(property.key)">
            <td>
              <ng-container *ngIf="isValidDate(property.value); else notValidDate">
                {{ property.value | date: 'yyyy-MM-dd HH:mm:ss' }}
              </ng-container>
              <ng-template #notValidDate>
                {{ property.value }}
              </ng-template>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </tbody>
  </table>  

  <ng-template #empty>
    <div class="text-center my-3">No records</div>
  </ng-template>
  <div class="text-center" *ngIf="this.count != this.displayedData.length && isLoading">
    loading...
  </div>

  <div class="modal fade" id="progressmodal" tabindex="1" data-backdrop="static" aria-hidden="true" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title align-self-center">{{this.displayedData.length}} of {{this.count}} has been downloaded: {{exportDownloadProgress}}%</h4>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">&times;</button> -->
        </div>
        <div class="modal-body p-0">
          <div class="card p-2">
            <div class="card-body p-2">
              Exporting...
              <p>{{writingToExcelText}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
